(() => {
    let active = false;

    let dispatchActivity = () => {
        if (active) {
            return;
        }
        active = true;
        document.dispatchEvent(new CustomEvent('UserInteracted'));
    };

    const interact = () => {
        let activities = [
            'mousedown', 
            'mousemove', 
            'keydown', 
            'scroll', 
            'touchstart', 
            'click', 
            'keypress', 
            'touchmove'
        ];
        const passiveEvents = ['scroll', 'touchstart', 'touchmove', 'mousemove'];
        activities.forEach((activity) => {
            const opts = passiveEvents.includes(activity) ? { passive: true, once: true } : { once: true };
            window.addEventListener(activity, dispatchActivity, opts);
        });
    };

    if (document.readyState !== 'loading') {
        interact();
    } else {
        document.addEventListener('DOMContentLoaded', interact, false);
    }

})();